import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { from, of, forkJoin } from "rxjs";
import { switchMap, finalize } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

import { ToastController } from "@ionic/angular";
import * as CryptoJS from "crypto-js";

const API_STORAGE_KEY = "specialkey";
const STORAGE_REQ_KEY = "storedreq";

interface StoredRequest {
  url: string;
  type: string;
  formData: any;
  time: number;
  id: string;
}

@Injectable({
  providedIn: "root",
})
export class OfflineManagerService {
  secret: string = "2DB0388F-5E28-4B4F-B9E2-6A281EF50253";
  constructor(
    private storage: Storage,
    private toastCtrl: ToastController,
    private http: HttpClient
  ) {}

  checkForEvents() {
    return from(this.storage.get(STORAGE_REQ_KEY)).pipe(
      switchMap((storedOperations) => {
        const storedObj = JSON.parse(storedOperations);
        if (storedObj && storedObj.length > 0) {
          return this.sendRequests(storedObj).pipe(
            finalize(() => {
              this.presentToast(`Local data succesfully synced to API!`);
              this.storage.remove(STORAGE_REQ_KEY);
            })
          );
        } else {
          console.log("no local events to sync");
          return of(false);
        }
      })
    );
  }

  sendRequests(operations: StoredRequest[]) {
    const obs = [];
    let formData = new FormData();

    for (const op of operations) {
      console.log("Make one request: ", op);
      //const data = JSON.stringify(op.formData);
      let data = op.formData;
      //Change Object to FormData
      formData = this.getFormData(data);
      //const oneObs = this.http.request(op.type, op.url, {body: formData});
      const oneObs = this.http.request(op.type, op.url, { body: formData });
      obs.push(oneObs);
    }

    // Send out all local events and return once they are finished.
    return forkJoin(obs);
  }
  //This function will change a Object to FormData
  getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }

  async presentToast(message) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "bottom",
    });
    toast.present();
  }

  storeRequest(url: any, type: any, data: any) {
    this.presentToast(
      `Your data is stored locally because you seem to be offline.`
    );

    const action: StoredRequest = {
      url: url,
      type: type,
      formData: data,
      time: new Date().getTime(),
      id: Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, "")
        .substr(0, 5),
    };
    // https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript

    return this.storage.get(STORAGE_REQ_KEY).then((storedOperations) => {
      let storedObj = JSON.parse(storedOperations);

      if (storedObj) {
        storedObj.push(action);
      } else {
        storedObj = [action];
      }
      // Save old & new local transactions back to Storage

      return this.storage.set(STORAGE_REQ_KEY, JSON.stringify(storedObj));
    });
  }

  // Save result of API requests
  public setLocalData(key, data) {
    //console.log('ApiService::setLocalData(key, data) | method called', key, data);
    data = this.encrypt(data, this.secret);
    this.storage.create().then(() => {
      this.storage.set(`${API_STORAGE_KEY}-${key}`, data);
    });
  }

  public async removeLocalData(key) {
    if ((await this.storage.get(`${API_STORAGE_KEY}-${key}`)) != null) {
      this.storage.remove(`${API_STORAGE_KEY}-${key}`);
    }
  }

  // Get cached API result
  public getLocalData(key) {
    //console.log('ApiService::getLocalData(key) | method called', key);

    return this.storage.get(`${API_STORAGE_KEY}-${key}`).then((data) => {
      return this.decrypt(data ? data : "", this.secret);
    });
  }

  encrypt(data, key) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
  }

  decrypt(data: string | null | undefined, key: string, keyHint?: string) {
    if (!data) return null;

    try {
      const bytes = CryptoJS.AES.decrypt(data, key);
      const plaintext = bytes.toString(CryptoJS.enc.Utf8);

      // Debug (kan jy later afhaal)
      if (!plaintext || !plaintext.trim()) {
        console.warn('Decrypt returned empty plaintext', { keyHint, dataLen: data.length });
        return null;
      }

      try {
        return JSON.parse(plaintext);
      } catch (jsonErr) {
        console.warn('Decrypt JSON parse failed (corrupt cache?)', {
          keyHint,
          plaintextLen: plaintext.length,
          preview: plaintext.slice(0, 120),
        });
        return null;
      }
    } catch (err) {
      console.warn('Decrypt failed', { keyHint, err });
      return null;
    }
  }
}
